import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { setSiteLang } from "@/lib/site";

const LangCtx = createContext({ lang: "id", setLang: () => {}, t: (id) => id });
const KEY = "minaqu-lang";

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => (localStorage.getItem(KEY) === "en" ? "en" : "id"));
  setSiteLang(lang);
  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((id, en) => (lang === "en" && en !== undefined ? en : id), [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="lang-toggle" className={`inline-flex rounded-full border border-leaf/25 bg-white p-0.5 ${className}`}>
      {["id", "en"].map((l) => (
        <button key={l} data-testid={`lang-toggle-${l}`} onClick={() => setLang(l)} aria-pressed={lang === l}
          className={`rounded-full px-2.5 py-1.5 font-display text-[11px] font-black uppercase transition-colors ${lang === l ? "bg-[var(--leaf)] text-white" : "text-[var(--leaf-deep)] hover:bg-[var(--mint)]"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
